// @ts-nocheck
import { Column } from 'react-table'
import { UserInfoCell } from './UserInfoCell'
import { PaymentScheme } from '../../../../../core/_models'
import CustomHeader from '../../../../../components/header/CustomHeader'
import { CreatedAtCell } from '../../../../../users/table/columns/CreatedAtCell'

const returnColumns = (navigate: any) => {
    const columns: ReadonlyArray<Column<PaymentScheme>> = [
        {
            Header: (props) => (
                <CustomHeader tableProps={props} title='Scheme ID' className='min-w-110px' />
            ),
            id: 'id',
            Cell: ({ ...props }) => (
                <UserInfoCell
                    user={props.data[props.row.index]}
                    col={
                        <button
                            className='p-0 border-0 bg-white text-primary fw-bold'
                            onClick={() => {
                                const id = props.data[props.row.index]?.id
                                if (id) {
                                    navigate(`/payments/schemes/${id}/details`)
                                }
                            }}
                        >
                            {props.data[props.row.index]?.id ?? 'N/A'}
                        </button>
                    }
                />
            ),
        },
        {
            Header: (props) => (
                <CustomHeader tableProps={props} title='Name' className='mw-125px' />
            ),
            id: 'name',
            Cell: ({ ...props }) => (
                <UserInfoCell
                    user={props.data[props.row.index]}
                    col={props.data[props.row.index]?.name ?? 'N/A'}
                />
            ),
        },
        {
            Header: (props) => (
                <CustomHeader tableProps={props} title='Status' className='mw-110px' />
            ),
            id: 'enabled',
            Cell: ({ ...props }) => (
                <UserInfoCell
                    user={props.data[props.row.index]}
                    col={props.data[props.row.index]?.enabled ? 'Enabled' : 'Disabled'}
                />
            ),
        },
        {
            Header: (props) => (
                <CustomHeader tableProps={props} title='Start Date' className='mw-125px' />
            ),
            id: 'startDateTime',
            Cell: ({ ...props }) => (
                <CreatedAtCell createdAt={props.data[props.row.index]?.startDateTime} />
            ),
        },
        {
            Header: (props) => (
                <CustomHeader tableProps={props} title='End Date' className='mw-125px' />
            ),
            id: 'endDateTime',
            Cell: ({ ...props }) => (
                <CreatedAtCell createdAt={props.data[props.row.index]?.endDateTime} />
            ),
        },
        {
            Header: (props) => (
                <CustomHeader tableProps={props} title='Tender Code' className='mw-125px' />
            ),
            id: 'ecrTenderTypeCode',
            Cell: ({ ...props }) => (
                <UserInfoCell
                    user={props.data[props.row.index]}
                    col={props.data[props.row.index]?.ecrTenderTypeCode ?? 'N/A'}
                />
            ),
        },
        {
            Header: (props) => (
                <CustomHeader tableProps={props} title='Type' className='mw-125px' />
            ),
            id: 'unitOfMeasure',
            Cell: ({ ...props }) => (
                <UserInfoCell
                    user={props.data[props.row.index]}
                    col={props.data[props.row.index]?.unitOfMeasure ?? 'N/A'}
                />
            ),
        },
        {
            Header: (props) => (
                <CustomHeader tableProps={props} title='Value' className='mw-100px' />
            ),
            id: 'preloadedAmount',
            Cell: ({ ...props }) => (
                <UserInfoCell
                    user={props.data[props.row.index]}
                    col={`${props.data[props.row.index]?.preloadedAmount}` ?? 'N/A'}
                />
            ),
        },
    ]
    return columns
}

export { returnColumns }
